import React, { useState, useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useNavigate, useOutletContext } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
//api
import { createBook } from 'api/libros';
import { createMerchandising } from 'api/merchandising';
//components
import Title from 'components/backoffice/texts/title';
import ProductForm from 'components/backoffice/forms/productsForm';

const CreateProduct = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false);
  const [resetValue, setResetValue] = useState(false);
  const [errorOnAction, setErrorOnAction] = useState({});
  const { t } = useTranslation(['backoffice']);
  const { setTitle } = useOutletContext()
  const fileInputRef = useRef(null);

  const product = {
    ean: '',
    titulo: '',
    titulo_orig: '',
    caratula: '',
    texto_resumen: '',
    num_en_coleccion: '',
    precio_sin_iva: '',
    precio_venta_publico: '',
    iva: '',
    ubicacion_stock: '',
    genero: '',
    publicada: false,
    cover: undefined,
    image: undefined,
    product_type: {
      id: "book",
      value: t('books')
    },
    alto_cm: '',
    ancho_cm: '',
    grosor_cm: '',
    peso: '',
    num_edicion: '',
    num_paginas: '',
    ibic: [],
    bookbindings: [],
    autor:[],
    idioma: [],
    publications_date: '',
  };

  const onSubmit = useCallback(async (values) => {
    setLoading(true);
    const data = {
      ean: values.ean,
      titulo: values.titulo,
      titulo_orig: values.titulo_org,
      caratula: values.caratula,
      texto_resumen: values.texto_resumen,
      num_en_coleccion: values.num_en_coleccion == undefined ? 0 : parseInt(values.num_en_coleccion),
      precio_sin_iva: values.precio_sin_iva,
      precio_venta_publico: values.precio_venta_publico,
      iva: parseInt(values.iva),
      ubicacion_stock: values.ubicacion_stock,
      editorial: values.editorial?.value,
      genero: values.genero,
      publicada: values.publicada,
      cover: values.cover,
      image: values.image,
      product_type: values.product_type?.id,
      options: JSON.stringify(values.options || []),

    };
    switch (values.product_type?.id) {
      case 'book':
        data.alto_cm = values.alto_cm
        data.ancho_cm = values.ancho_cm
        data.grosor_cm = values.grosor_cm
        data.peso = values.peso === ""? 0 : Math.trunc(values.peso)
        data.num_edicion = values.num_edicion
        data.num_paginas = values.num_paginas
        data.ibic = Array.isArray(values.ibic) ? values.ibic.map(item => item.value) : []
        data.encuadernacion = Array.isArray(values.bookbindings) ? values.bookbindings.map(item => item.value) : []
        data.authors = Array.isArray(values.authors) ? values.authors.map(item => item.value) : []
        data.fecha_public = values.publication_date === '1-01-01' ? moment('2021-01-01').local().format('YYYY-MM-DD') : moment(values.publication_date).local().format('YYYY-MM-DD');
        data.languages = Array.isArray(values.languages) ? values.languages.map(item => item.value) : []
        if (values.availabled_status && typeof values.availabled_status === 'object') {
          const formattedStatus = {};
          Object.entries(values.availabled_status).forEach(([code, hasStock]) => {
            formattedStatus[code] = hasStock === true ? 2 : 1;
          });
          data.availabled_status = formattedStatus;
        }
        break;
      case 'merchandising':
        break;
      default:
        break;
    }
    try {
      const response = values.product_type.id === 'book' ? await createBook(data) : await createMerchandising(data);
      if (response.status === 201) {
        toast.success(t('creadocorrectamente'));
        setResetValue(true);
        navigate('/intranet/products', { replace: true });
      } else {
        setErrorOnAction(response.data)
        setResetValue(false);
        toast(`${t('error')} ${response.status}: ${t('mensajeerror')}`);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    setTitle(t('createproduct'))
    return () => {
      setTitle('');
    };
  }, [setTitle])

  return (
    <div className="mt-3">
      <Title text={t('createproduct')} />
      <ProductForm
        loading={loading}
        isEditing={false}
        onSubmitForm={onSubmit}
        defaultValues={product}
        fileInputRef={fileInputRef}
        beforeTitle={t('createproduct')}
        resetValue={resetValue}
        errorOnAction={errorOnAction} />
    </div>
  );
};

export default CreateProduct;